import { useEffect, useMemo, useState } from "react";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Input from "../components/Input";
import Button from "../components/Button";
import {
  getMessages,
  addCategory,
  deleteCategory,
  addMessage,
  updateMessage,
  deleteMessage,
  cleanupMessages,
} from "../api/messages";

export default function MessagesPage({ onNavigate }) {
  const [data, setData] = useState({});
  const [selected, setSelected] = useState("");
  const [newCat, setNewCat] = useState("");
  const [newMsg, setNewMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const categories = useMemo(() => Object.keys(data || {}).sort(), [data]);
  const list = data?.[selected] || [];

  async function refresh() {
    const r = await getMessages();
    setData(r.messages || {});
    if (!selected && Object.keys(r.messages || {}).length) {
      setSelected(Object.keys(r.messages)[0]);
    }
  }

  useEffect(() => {
    refresh().catch(() => {});
    // eslint-disable-next-line
  }, []);

  async function act(fn) {
    setErr("");
    setBusy(true);
    try {
      const r = await fn();
      if (r?.messages) setData(r.messages);
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout
      title="Mesaj Kategorileri"
      right={
        <div style={{ display: "flex", gap: 8 }}>
          <Button variant="secondary" onClick={() => onNavigate?.("dashboard")}>
            Dashboard'a Dön
          </Button>

          <Button onClick={() => act(() => cleanupMessages())} disabled={busy}>
            Temizle / Düzelt
          </Button>
        </div>
      }
    >
      <div className="grid">
        <Card>
          <div className="h2">Kategori</div>
          <div className="stack">
            <Input
              label="Yeni kategori key"
              value={newCat}
              onChange={(e) => setNewCat(e.target.value)}
            />
            <Button
              onClick={() => act(() => addCategory(newCat.trim()))}
              disabled={busy || !newCat.trim()}
            >
              Kategori Ekle
            </Button>

            <div className="list" style={{ marginTop: 10 }}>
              {categories.map((k) => (
                <div key={k} className="row">
                  <div style={{ flex: 1 }}>
                    <b>{k}</b>{" "}
                    <span className="muted">({(data[k] || []).length})</span>
                  </div>
                  <Button variant="secondary" onClick={() => setSelected(k)}>
                    Aç
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => act(() => deleteCategory(k))}
                    disabled={busy}
                  >
                    Sil
                  </Button>
                </div>
              ))}
              {categories.length === 0 ? (
                <div className="muted">Kategori yok.</div>
              ) : null}
            </div>

            {err ? <div className="error">{err}</div> : null}
          </div>
        </Card>

        <Card>
          <div className="h2">Mesajlar: {selected || "-"}</div>

          {!selected ? (
            <div className="muted">Soldan bir kategori seç.</div>
          ) : (
            <div className="stack">
              <Input
                label="Yeni mesaj"
                value={newMsg}
                onChange={(e) => setNewMsg(e.target.value)}
              />
              <Button
                onClick={() => act(() => addMessage(selected, newMsg))}
                disabled={busy || !newMsg.trim()}
              >
                Mesaj Ekle
              </Button>

              <div className="list" style={{ marginTop: 10 }}>
                {list.map((m, idx) => (
                  <MessageRow
                    key={`${idx}-${m}`}
                    text={m}
                    onSave={(t) => act(() => updateMessage(selected, idx, t))}
                    onDelete={() => act(() => deleteMessage(selected, idx))}
                    busy={busy}
                  />
                ))}
                {list.length === 0 ? (
                  <div className="muted">Bu kategoride mesaj yok.</div>
                ) : null}
              </div>
            </div>
          )}
        </Card>
      </div>
    </Layout>
  );
}

function MessageRow({ text, onSave, onDelete, busy }) {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState(text);

  if (!edit) {
    return (
      <div className="row">
        <div style={{ flex: 1, wordBreak: "break-word" }}>{text}</div>
        <Button variant="secondary" onClick={() => setEdit(true)}>
          Düzenle
        </Button>
        <Button variant="ghost" onClick={onDelete} disabled={busy}>
          Sil
        </Button>
      </div>
    );
  }

  return (
    <div
      className="stack"
      style={{
        padding: 10,
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 10,
      }}
    >
      <Input label="Mesaj" value={v} onChange={(e) => setV(e.target.value)} />
      <div style={{ display: "flex", gap: 8 }}>
        <Button
          onClick={() => {
            onSave(v);
            setEdit(false);
          }}
          disabled={busy || !v.trim()}
        >
          Kaydet
        </Button>
        <Button
          variant="ghost"
          onClick={() => {
            setV(text);
            setEdit(false);
          }}
          disabled={busy}
        >
          Vazgeç
        </Button>
      </div>
    </div>
  );
}
